import { Injectable } from '@angular/core';
import {
    ApiIntegrationCardDefinition,
    IntegrationCardDefinition,
} from '@/home/settings/integrations/integration-card/integration-card.types';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class IntegrationProvider {
    /**
     * This method defines extra information for integrations which are provided by the Api.
     * If an API integration is not listed here, it will be treated without additional information.
     */
    public getApiIntegrationExtensions(): ApiIntegrationCardDefinition[] {
        const meinbueroProdUrl = 'https://app.meinbuero.de/apps/all/show/69f35c00e31c99183781935a';
        const meinbueroAllUrl = 'https://app.meinbuero.de/apps/all';
        const meinbeuroConnectUrl = environment.production ? meinbueroProdUrl : meinbueroAllUrl;

        const orgamaxAllUrl = 'https://app.orgamax.de/apps/all';
        // TODO: replace with the published extension URL once our orgaMAX marketplace app exists:
        // 'https://app.orgamax.de/apps/all/show/<appId>'. Until then production falls back to the
        // same marketplace overview page as non-production, where the user picks the app manually.
        const orgamaxProdUrl = 'https://app.orgamax.de/apps/all/show/6a956f482f086b732ae45a92';
        const orgamaxConnectUrl = environment.production ? orgamaxProdUrl : orgamaxAllUrl;

        return [
            {
                serviceId: 'lexware',
                category: ['accounting'],
                devStatus: 'stable',
            },
            {
                serviceId: 'sevdesk',
                category: ['accounting'],
                devStatus: 'beta',
                extras: {
                    apiKeyPageUrl: 'https://my.sevdesk.de/admin/integrations',
                },
            },
            {
                serviceId: 'bexio',
                category: ['accounting'],
                devStatus: 'beta',
            },
            {
                serviceId: 'fastbill',
                category: ['accounting'],
                devStatus: 'beta',
                extras: {
                    apiKeyPageUrl: 'https://my.fastbill.com/index.php?s=D7GCLx0WuylFq3nl4gAvRQMwS8RDyb3sCe_bEoXoU_w',
                },
            },
            {
                serviceId: 'meinbuero',
                category: ['accounting'],
                devStatus: 'beta',
                extras: {
                    connectUrl: meinbeuroConnectUrl,
                },
            },
            {
                serviceId: 'orgamax',
                category: ['accounting'],
                devStatus: 'beta',
                extras: {
                    connectUrl: orgamaxConnectUrl,
                },
            },
        ];
    }

    /**
     * This method defines integrations that are not invented by timeBuzzer.
     * There integrations are hard coded solely frontend based.
     */
    public getIntegrations(): IntegrationCardDefinition[] {
        return [
            {
                serviceId: 'milkee',
                category: ['accounting'],
                link: 'https://timebuzzer.com/integrations/milkee/',
                vendor: 'Milkee',
            },
            {
                serviceId: 'grandtotal',
                category: ['accounting'],
                link: 'https://www.mediaatelier.com/de/Integrations/',
                vendor: 'Grandtotal',
            },
            {
                serviceId: 'make',
                category: ['automate'],
                link: 'https://www.make.com/en/integrations/timebuzzer',
                vendor: 'Make',
            },
            {
                serviceId: 'zapier',
                category: ['automate'],
                link: 'https://zapier.com/apps/timebuzzer/integrations',
                vendor: 'Zapier',
            },
            {
                serviceId: 'integrately',
                category: ['automate'],
                link: 'https://integrately.com/integrations/timebuzzer',
                vendor: 'Integrately',
            },
            {
                serviceId: 'sally',
                category: ['automate'],
                link: 'https://www.sally.io/',
                vendor: 'Sally',
            },
        ];
    }
}
